import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useClientAuth } from '../../auth/ClientAuthContext';
import API_BASE from '../../utils/api';
import '../../styles/AuthForm.css';

export default function ClientLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { clientLogin } = useClientAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/client/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email: email.trim().toLowerCase(), password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data?.error || 'Login failed. Please try again.');
        return;
      }

      clientLogin(data);
      navigate('/client/dashboard', { replace: true });
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-form">
      <img src="/logo.png" alt="InteriorFolio Logo" className="auth-logo" />

      <form className="auth-card" onSubmit={handleSubmit}>
        <h2>Client Portal</h2>
        <p className="auth-subtitle">Sign in to view your projects and documents.</p>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => { setEmail(e.target.value); if (error) setError(''); }}
          aria-invalid={Boolean(error)}
          required
          autoComplete="email"
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => { setPassword(e.target.value); if (error) setError(''); }}
          aria-invalid={Boolean(error)}
          required
          autoComplete="current-password"
        />

        {error && (
          <div className="auth-error-banner" role="alert" aria-live="polite">
            <strong>Unable to sign in.</strong> {error}
          </div>
        )}

        <button type="submit" disabled={loading}>
          {loading ? 'Signing in…' : 'Sign In'}
        </button>

        <p style={{ fontSize: '0.82rem', color: '#6b7280', marginTop: '1.25rem' }}>
          Don't have an account? Check your email for an invite from your designer.
        </p>
      </form>

      <p style={{ marginTop: '1rem', fontSize: '0.78rem', color: '#9ca3af', textAlign: 'center' }}>
        Are you a designer?{' '}
        <Link to="/" style={{ color: '#62794e', fontWeight: 600, textDecoration: 'none' }}>
          Designer login →
        </Link>
      </p>
    </div>
  );
}
